(() => {
  if (window.llMobileServicesInstalled) return;
  window.llMobileServicesInstalled = true;
  const observedChatRoots = new WeakSet();
  const nativeChatButton = () => {
    const root = document.querySelector('shopify-chat')?.shadowRoot;
    return root?.querySelector('button[part="activator"]') || root?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('button[part="activator"]');
  };
  const watchChatRoots = () => {
    const root = document.querySelector('shopify-chat')?.shadowRoot;
    [root, root?.querySelector('shopify-agent-runtime')?.shadowRoot, document.querySelector('#smile-ui-container')].filter(Boolean).forEach((chatRoot) => {
      if (observedChatRoots.has(chatRoot)) return;
      observedChatRoots.add(chatRoot);
      new MutationObserver(syncChat).observe(chatRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['title'] });
    });
  };
  const syncChat = () => {
    watchChatRoots();
    document.documentElement.classList.toggle('ll-services-chat-ready', Boolean(nativeChatButton() && document.querySelector('[data-ll-open-chat]')));
    document.documentElement.classList.toggle('ll-services-rewards-ready', Boolean(document.querySelector('#smile-lite-launcher-frame, iframe[title="Button to open loyalty program pop-up"]') && document.querySelector('[data-ll-open-rewards]')));
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-ll-open-chat]');
    if (!link) return;
    const activator = nativeChatButton();
    if (!activator) { syncChat(); return; }
    event.preventDefault();
    const chat = document.querySelector('shopify-chat');
    if (typeof chat?.show === 'function') chat.show();
    else activator.click();
  });
  document.addEventListener('shopify:section:load', syncChat);
  let attempts = 0;
  const timer = window.setInterval(() => {
    syncChat();
    if ((document.documentElement.classList.contains('ll-services-chat-ready') && document.documentElement.classList.contains('ll-services-rewards-ready')) || ++attempts >= 60) window.clearInterval(timer);
  }, 1000);
  const observer = new MutationObserver(syncChat);
  observer.observe(document.body, { childList: true });
  syncChat();
})();
